import type { CombatRatings } from "@/game/model/character-stats";
import { getGameSettings } from "@/game/model/game-settings";

/** Base max mana before stat bonuses. */
export const COMBAT_MANA_BASE = 100;

/** Mana spent per skill cast. */
export const SKILL_MANA_COST = 20;

/** 1 mana every 2 seconds. */
export const COMBAT_MANA_REGEN_PER_SEC = 0.5;

export function playerCombatMaxMana(ratings: CombatRatings): number {
  const s = getGameSettings();
  return Math.floor(COMBAT_MANA_BASE + ratings.manaMaxBonus * s.playerManaPerStat);
}

export function combatManaRegenPerSec(): number {
  return COMBAT_MANA_REGEN_PER_SEC;
}
